<template>
  <div class="ux-progress">
    <div class="ux-progress-bg" :class="{ active }" />
    <div class="ux-progress-fg" :style="barStyle" />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
    },
    active: {
      type: Boolean,
    },
  },
  computed: {
    classes() {
      var array = [];

      array.push(this.icon);

      if (this.spin) {
        array.push(`fa-spin`);
      }

      if (this.left) {
        array.push("ux-icon-left");
      }
      if (this.right) {
        array.push("ux-icon-right");
      }
      return array;
    },
    percent() {
      return this.value;
    },
    barStyle() {
      return {
        width: `${this.percent}%`,
      };
    },
    element() {
      return "i";
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-progress {
  margin: 1em 0;
  position: relative;
  height: 1em;
  overflow: hidden;
  border-radius: 0.5em;
}

@keyframes stripes {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
}

.ux-progress-bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: rgba(#000, 0.03);

  box-shadow: inset 0px 0.3em 0.3em rgba(#000, 0.1);

  &:before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    box-shadow: inset 0px 0.3em 0.3em rgba(#000, 0.1);
  }

  &.active:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    background-image: linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.8) 5%,
      transparent 10%,
      rgba(255, 255, 255, 0.8) 15%,
      transparent 20%,
      rgba(255, 255, 255, 0.8) 25%,
      transparent 30%,
      rgba(255, 255, 255, 0.8) 35%,
      transparent 40%,
      rgba(255, 255, 255, 0.8) 45%,
      transparent 50%,
      rgba(255, 255, 255, 0.8) 55%,
      transparent 60%,
      rgba(255, 255, 255, 0.8) 65%,
      transparent 70%,
      rgba(255, 255, 255, 0.8) 75%,
      transparent 80%,
      rgba(255, 255, 255, 0.8) 85%,
      transparent 90%,
      rgba(255, 255, 255, 0.8) 95%,
      transparent
    );

    background-size: 50px 50px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    overflow: hidden;
    animation: stripes 4s infinite linear;
  }
}

.ux-progress-fg {
  background: var(--primary);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  border-radius: 0.5em;
  opacity: 1;
  transition: all 0.2s;
}
</style>
